import React, { useState } from 'react';
import { Button, Space } from 'antd';
import { variantTokens } from '../../../theme/theme';
import SmallModal from '../Modals/SmallModal';
import MediumModal from '../Modals/MediumModal';
import FullScreenModal from '../Modals/FullScreenModal';

// Costanti dei colori
const PRIMARY = variantTokens.primary;
const ERROR = variantTokens.error;

const ModalSection = () => {
    // Stati per controllare la visibilità dei modali
    const [isSmallModalVisible, setIsSmallModalVisible] = useState(false);
    const [isMediumModalVisible, setIsMediumModalVisible] = useState(false);
    const [isFullModalVisible, setIsFullModalVisible] = useState(false);

    // Funzioni per gestire l'apertura e chiusura dei modali
    const showSmallModal = () => {
        setIsSmallModalVisible(true);
    };

    const showMediumModal = () => {
        setIsMediumModalVisible(true);
    };

    const showFullModal = () => {
        setIsFullModalVisible(true);
    };

    const handleCloseSmallModal = () => {
        setIsSmallModalVisible(false);
    };

    const handleCloseMediumModal = () => {
        setIsMediumModalVisible(false);
    };

    const handleCloseFullModal = () => {
        setIsFullModalVisible(false);
    };

    // Esempio di funzioni per gestire la conferma
    const handleSmallConfirm = () => {
        console.log('Small modal confirm clicked');
        // Aggiungi qui la logica per l'azione di conferma
    };

    const handleMediumConfirm = () => {
        console.log('Medium modal confirm clicked');
        // Aggiungi qui la logica per l'azione di conferma
    };

    const handleFullConfirm = () => {
        console.log('Full screen modal confirm clicked');
        // Aggiungi qui la logica per l'azione di conferma
    };

    return (
        <div>
            {/* Bottoni per aprire i modali */}
            <Space
                size={16}
                style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                }}
            >
                <Button
                    type="primary"
                    onClick={showSmallModal}
                    style={{
                        backgroundColor: PRIMARY,
                        borderColor: PRIMARY,
                        fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                        padding: 'clamp(0.25rem, 1vw, 0.5rem) clamp(0.5rem, 2vw, 1rem)',
                        height: 'auto',
                        minHeight: 'clamp(2rem, 5vw, 2.25rem)'
                    }}
                >
                    Open Small Modal
                </Button>
                <Button
                    type="primary"
                    onClick={showMediumModal}
                    style={{
                        backgroundColor: PRIMARY,
                        borderColor: PRIMARY,
                        fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                        padding: 'clamp(0.25rem, 1vw, 0.5rem) clamp(0.5rem, 2vw, 1rem)',
                        height: 'auto',
                        minHeight: 'clamp(2rem, 5vw, 2.25rem)'
                    }}
                >
                    Open Medium Modal
                </Button>
                <Button
                    type="primary"
                    onClick={showFullModal}
                    style={{
                        backgroundColor: ERROR,
                        borderColor: ERROR,
                        fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                        padding: 'clamp(0.25rem, 1vw, 0.5rem) clamp(0.5rem, 2vw, 1rem)',
                        height: 'auto',
                        minHeight: 'clamp(2rem, 5vw, 2.25rem)'
                    }}
                >
                    Open Full Screen Modal
                </Button>
            </Space>

            {/* Utilizzo dei componenti Modal separati */}
            <SmallModal
                visible={isSmallModalVisible}
                onClose={handleCloseSmallModal}
                onConfirm={handleSmallConfirm}
            />

            <MediumModal
                visible={isMediumModalVisible}
                onClose={handleCloseMediumModal}
                onConfirm={handleMediumConfirm}
            />

            <FullScreenModal
                visible={isFullModalVisible}
                onClose={handleCloseFullModal}
                onConfirm={handleFullConfirm}
            />
        </div>
    );
};

export default ModalSection; 